/* global Swiper */
const $ = window.jQuery;

$(document).ready(() => {
    // only relevant to groups landing page
    if (!$('.page-template-groups-landing-page').length) {
        return;
    }

    const swiper = new Swiper('.photoGalleryThumbnails', {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            480: {
                slidesPerView: 7,
            },
        },
    });

    const swiper2 = new Swiper('.photoGallery', {
        loop: false,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper,
        },
    });

    const toggleDropdown = (e) => {
        if (
            $(e.target).is('[class*="_dropdown"]') ||
            $(e.target).parents('[class*="_dropdown"]').length
        ) {
            if (!$(e.target).is('a') && !$(e.target).parents('a').length) {
                e.preventDefault();
                e.stopPropagation();
            }
        }

        if (
            !$(e.target).is('[dropdown]') &&
            !$(e.target).parents('[class*="_dropdown--menu"]').length
        ) {
            $('[dropdown]').attr('state', 'closed');
            $('[dropdown]').attr('clicked', null);
        } else if (!$(e.target).parents('[class*="_dropdown--menu"]').length) {
            if (e.type === 'click') {
                if ($(e.target).attr('clicked') !== undefined) {
                    $(e.target).attr(
                        'state',
                        $(e.target).attr('state') === 'open'
                            ? 'closed'
                            : 'open',
                    );
                } else {
                    $(e.target).attr('clicked', '');
                }
            } else {
                $(e.target).attr('state', 'open');
            }
        }
    };

    $('html, body').on('click', toggleDropdown);
    $('html, body').on('focus', '*', toggleDropdown);
});
